exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-GameApiActivity-GameApiActivity__view--2TLyL{display:block;background-color:#15262a;line-height:36rem;width:160rem;text-align:left;color:#fff;border:none;cursor:pointer;position:absolute;right:-10rem;top:20rem;padding:0 20rem;z-index:200}", ""]);
// Exports
exports.locals = {
	"view": "src-components-GameApiActivity-GameApiActivity__view--2TLyL"
};